import { render } from "./NewsList.vue?vue&type=template&id=85ff82e8"
import script from "./NewsList.vue?vue&type=script&lang=ts"
export * from "./NewsList.vue?vue&type=script&lang=ts"
script.render = render

export default script